var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38665 28.7308C2.49819 28.7308 1.73788 28.4147 1.10573 27.7825C0.472499 27.1493 0.155884 26.3885 0.155884 25.5V10.9615C0.155884 10.45 0.270576 9.96539 0.49996 9.5077C0.728268 9.05001 1.04435 8.67309 1.44819 8.37693L11.1405 1.1077C11.4367 0.892317 11.7463 0.730778 12.0693 0.623086C12.3924 0.515394 12.729 0.461548 13.079 0.461548C13.429 0.461548 13.7655 0.515394 14.0886 0.623086C14.4117 0.730778 14.7213 0.892317 15.0174 1.1077L24.7097 8.37693C25.1136 8.67309 25.4302 9.05001 25.6596 9.5077C25.8879 9.96539 26.002 10.45 26.002 10.9615V25.5C26.002 26.3885 25.686 27.1493 25.0538 27.7825C24.4206 28.4147 23.6597 28.7308 22.7713 28.7308H16.3097V17.4231H9.84819V28.7308H3.38665Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.45007eb07fb922252e6ba9805bbef294.svg";
export { ForwardRef as ReactComponent };